import { library } from "@fortawesome/fontawesome-svg-core";
import { faClassicIcon, faFlashIcon, faFscLogoIcon, faLivePayIcon, faDriveBuzzIcon, faZBIcon, faAZRIcon, faEARIcon, faKTRIcon } from "@/icons/index";

library.add(faClassicIcon, faFlashIcon, faFscLogoIcon, faLivePayIcon, faDriveBuzzIcon, faZBIcon, faAZRIcon, faEARIcon, faKTRIcon);
